import { z } from 'zod';

import { GlyTouCanError } from '@/types/error';

export const validate = <T extends z.ZodSchema>(
  value: unknown,
  schema: T,
  url?: string,
): z.infer<T> => {
  const validationResult = schema.safeParse(value);
  if (validationResult.success) {
    return validationResult.data;
  }
  const errorDetails = validationResult.error.errors.map(err => ({
    path: err.path.join('.'),
    message: err.message,
  }));
  throw new GlyTouCanError({
    message: `Validation failed: ${JSON.stringify(errorDetails)}`,
    errorType: 'SCHEMA_VALIDATION_ERROR',
    name: 'SchemaValidationError',
    url: url,
  });
};
